<ng-container *ngIf="!requiresVerification && !requires2FASetup && !requiresTOTP; else postLoginSteps">


  <div nz-row>
      <div
          nz-col
          nzSpan="8"
          nzOffset="8"
          [ngClass]="'login p-3'"
      >

                  <nz-alert
                      *ngIf="error"
                      nzType="error"
                      nzMessage="{{error}}"
                      nzShowIcon
                  ></nz-alert>
      
          <h1 nz-typography>Autentificare</h1>
      
          <ng-container *ngIf="accountCreated">
              <nz-alert
                  nzType="success"
                  nzMessage="Contul a fost creat cu success"
                  nzDescription="Verifică mail-ul pentru activarea contului. Uită-te și în spam te rog!"
              ></nz-alert>
          </ng-container>
          <ng-container *ngIf="passwordReset">
              <nz-alert
                  nz-Class=""
                  nzType="success"
                  nzMessage="Cererea de resetare a parolei a fost creată cu succes"
                  nzDescription="A fost trimis un email cu link-ul pentru resetarea parolei. Uita-te și în spam te rog!"
              ></nz-alert>
          </ng-container>
          <ng-container *ngIf="!accountCreated && !passwordReset">
              <form
                  nz-form
                  [formGroup]="loginForm"
                  class="login-form"
                  (ngSubmit)="onSubmit()"
              >
                  <nz-form-item>
                      <nz-form-control nzErrorTip="Scrie emailul tau.">
                          <nz-input-group [nzPrefix]="prefixEmail">
                              <input
                                  type="text"
                                  nz-input
                                  formControlName="username"
                                  placeholder="Email"
                              >
                          </nz-input-group>
                          <ng-template #prefixEmail>
                              <i
                                  nz-icon
                                  nzType="mail"
                                  nzTheme="outline"
                              ></i>
                          </ng-template>
                      </nz-form-control>
                  </nz-form-item>
                  <nz-form-item>
                      <nz-form-control nzErrorTip="Scrie parola.">
                          <nz-input-group [nzPrefix]="prefixPassword" [nzSuffix]="suffixTemplate">
                              <input
                                  [type]="passwordVisible ? 'text' : 'password'"
                                  nz-input
                                  formControlName="password"
                                  placeholder="Parola"
                              >
                          </nz-input-group>
                          <ng-template #prefixPassword>
                              <i
                                  nz-icon
                                  nzType="lock"
                                  nzTheme="outline"
                              ></i>
                          </ng-template>
                          <ng-template #suffixTemplate>
                              <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="passwordVisible = !passwordVisible"></i>
                            </ng-template>
                      </nz-form-control>
                  </nz-form-item>
                  <div
                      nz-row
                      class="login-form-margin"
                  >
                      <!-- <div nz-col [nzSpan]="12">
                          <label nz-checkbox formControlName="remember">
                              <span>Remember me</span>
                          </label>
                      </div> -->
                      <button
                          nz-button
                          class="login-form-button login-form-margin"
                          [nzType]="'primary'"
                          [nzLoading]="loading"
                      >
                          Conectare
                      </button>
                      <div
                          nz-col
                          [nzSpan]="24"
                          class="login-links"
                      >
                          <a
                              class="login-form-forgot"
                              routerLink="/forgot-password"
                              (click)="goTop()"
                          >
                              Ai uitat parola?
                          </a>
                          <a
                              routerLink="/register"
                              (click)="goTop()"
                          >
                              Nu ai cont? Înregistreză-te!
                          </a>
                      </div>
                  </div>

              </form>
          </ng-container>
      </div>
  </div>
</ng-container>

<!-- Post-login steps: Email verification OR 2FA Setup -->
<ng-template #postLoginSteps>
  
  <!-- Step 2: Email Verification -->
  <ng-container *ngIf="requiresVerification && !requires2FASetup && !requiresTOTP">
  <div nz-row>
      <div
          nz-col
          nzSpan="8"
          nzOffset="8"
          [ngClass]="'login p-3'"
      >
    <!-- <div class="login-container"> -->
    <!--   <div class="login-box verification-box"> -->
              <!-- Warning about device replacement -->
        <div class="verification-header">
          <button type="button" class="back-button" (click)="backToLogin()">
            <i class="fa fa-arrow-left"></i>
          </button>
          <h2>{{ deviceType === 'mobile' ? '📱 Telefon nou' : '💻 Calculator nou' }} detectat</h2>
        </div>
        <div *ngIf="replacingDevice" class="replacement-warning">
  <p [innerHTML]="getReplacementWarning()"></p>
</div>


        <div class="step-indicator">
          <span class="step active">1. Verificare email</span>
          <span class="step">2. Configurare 2FA</span>
        </div>

        <div class="verification-icon">
          <i [class]="deviceType === 'mobile' ? 'fa fa-mobile-alt' : 'fa fa-laptop'"></i>
          <i class="fa fa-question-circle overlay-icon"></i>
        </div>

        <p class="verification-description">
          Am detectat că încercați să vă autentificați de pe un 
          <strong>{{ deviceType === 'mobile' ? 'telefon mobil' : 'calculator/laptop' }} nou</strong>.
          <br><br>
          <strong>Am trimis un cod de verificare la:</strong>
          <br>
          <span class="masked-email">{{ verificationMethods?.user_email }}</span>
        </p>

        <!-- Warning about device replacement -->
        <div *ngIf="replacingDevice" class="replace-warning">
          <i class="fa fa-exclamation-triangle"></i>
          <span>
            Acest dispozitiv va înlocui: <strong>{{ replacingDevice }}</strong>
          </span>
        </div>

        <!-- Error/Success message -->
        <div *ngIf="verificationError" class="alert" 
             [class.alert-danger]="!verificationError.includes('retrimis')"
             [class.alert-success]="verificationError.includes('retrimis')">
          {{ verificationError }}
        </div>

        <form [formGroup]="verificationForm" (ngSubmit)="onSubmitVerification()">
          <div class="form-group">
            <label for="verificationCode">Cod de verificare din email&nbsp;</label>
            <input 
              type="text" 
              id="verificationCode"
              formControlName="code" 
              class="form-control code-input"
              placeholder="000000"
              maxlength="9"
              autocomplete="one-time-code"
              [class.is-invalid]="vf.code.touched && vf.code.errors"
            />
            <div *ngIf="vf.code.touched && vf.code.errors" class="invalid-feedback">
              <span *ngIf="vf.code.errors.required">Codul este obligatoriu</span>
              <span *ngIf="vf.code.errors.minlength">Codul trebuie să aibă cel puțin 6 caractere</span>
            </div>
          </div>

          <div class="form-group form-check">
            <input 
              type="checkbox" 
              id="trustDevice"
              formControlName="trustDevice" 
              class="form-check-input"
            />
            <label for="trustDevice" class="form-check-label">
              Salvează acest {{ deviceType === 'mobile' ? 'telefon' : 'calculator' }} ca dispozitiv de încredere
            </label>
          </div>

          <button 
                          nz-button
                          class="login-form-button login-form-margin"
                          [nzType]="'primary'"
            type="submit" 
            [disabled]="loading"
          >
            <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
            <span *ngIf="!loading">Continuă</span>
          </button>
        </form>

        <!-- Resend code -->
        <div class="resend-section">
          <p>Nu ai primit codul?</p>
          <button 
            type="button" 
            class="btn btn-link"
            (click)="resendCode()"
            [disabled]="resendDisabled"
          >
            <span *ngIf="resendDisabled">Retrimite codul ({{ resendCountdown }}s)</span>
            <span *ngIf="!resendDisabled">Retrimite codul</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="requiresTOTP && !requires2FASetup && !requiresVerification">
  <div nz-row>
    <div nz-col nzSpan="8" nzOffset="8" [ngClass]="'login p-3'">
      <div class="verification-header">
        <button type="button" class="back-button" (click)="backToLogin()">
          <i class="fa fa-arrow-left"></i>
        </button>
        <h2>🔐 Verificare în 2 pași</h2>
      </div>

      <div class="step-indicator">
        <span class="step completed">✓ Email verificat</span>
        <span class="step active">2. Cod authenticator</span>
      </div>

      <p class="verification-description">
        Introdu codul de 6 cifre din aplicația ta de autentificare
        (Google Authenticator, Authy, etc.)
      </p>

      <!-- Error message -->
      <nz-alert *ngIf="verificationError" nzType="error" [nzMessage]="verificationError" nzShowIcon></nz-alert>

      <form [formGroup]="totpVerifyForm" (ngSubmit)="onSubmitTOTPVerify()">
        <div class="form-group">
          <label for="totpCode">Cod din aplicație</label>
          <input 
            type="text" 
            id="totpCode"
            formControlName="code" 
            class="form-control code-input"
            placeholder="000000"
            maxlength="6"
            autocomplete="one-time-code"
          />
        </div>

        <button 
          nz-button
          class="login-form-button login-form-margin"
          [nzType]="'primary'"
          type="submit" 
          [nzLoading]="loading"
        >
          Verifică
        </button>
      </form>

      <div class="backup-code-hint" style="margin-top: 16px; text-align: center;">
        <small style="color: #888;">
          Poți folosi și un cod de rezervă dacă nu ai acces la aplicație.
        </small>
      </div>
    </div>
  </div>
</ng-container>


  <!-- Step 3: Forced 2FA Setup -->
  <ng-container *ngIf="requires2FASetup && !showBackupCodes">
    <div nz-row>
      <div nz-col nzSpan="8" nzOffset="8" [ngClass]="'login p-3'">
        <div class="verification-header">
          <h2>🔐 Configurare autentificare în 2 pași</h2>
        </div>

        <div class="step-indicator">
          <span class="step completed">✓ Verificare email</span>
          <span class="step active">2. Configurare 2FA</span>
        </div>

        <div class="setup-info">
          <i class="fa fa-shield-alt"></i>
          <p>
            Pentru securitatea contului tău, trebuie să configurezi autentificarea în 2 pași.
            Aceasta te protejează chiar dacă cineva află parola ta.
          </p>
        </div>

        <div class="setup-instructions">
          <h4>Pași:</h4>
          <ol>
            <li>Descarcă <strong>Google Authenticator</strong> sau <strong>Authy</strong> pe telefon</li>
            <li>Scanează codul QR de mai jos cu aplicația</li>
            <li>Introdu codul de 6 cifre generat de aplicație</li>
          </ol>
        </div>

        <!-- QR Code -->
        <div class="qr-code-container" *ngIf="setupData">
          <img [src]="'data:image/png;base64,' + setupData.qr_code" alt="QR Code pentru 2FA" class="qr-code" />
        </div>

        <!-- Manual entry -->
        <div class="manual-entry" *ngIf="setupData">
          <p>Nu poți scana? Introdu manual acest cod:</p>
          <div class="secret-key">
            <code>{{ setupData.secret }}</code>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="copySecret()">
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </div>

        <!-- Error message -->
        <nz-alert *ngIf="setupError" nzType="error" [nzMessage]="setupError" nzShowIcon></nz-alert>

        <!-- TOTP verification form -->
        <form [formGroup]="totpSetupForm" (ngSubmit)="onSubmitTOTPSetup()">
          <div class="form-group">
            <label for="totpSetupCode">Cod din aplicație</label>
            <input 
              type="text" 
              id="totpSetupCode"
              formControlName="code" 
              class="form-control code-input"
              placeholder="000000"
              maxlength="6"
              autocomplete="one-time-code"
            />
          </div>

          <button 
            nz-button
            class="login-form-button login-form-margin"
            [nzType]="'primary'"
            type="submit" 
            [nzLoading]="loading"
          >
            Activează 2FA
          </button>
        </form>
      </div>
    </div>
  </ng-container>

  <!-- Step 4: Backup Codes -->
  <ng-container *ngIf="showBackupCodes">
    <div nz-row>
      <div nz-col nzSpan="8" nzOffset="8" [ngClass]="'login p-3'">
        <div class="verification-header">
          <h2>✅ 2FA Activat cu succes!</h2>
        </div>

        <div class="step-indicator">
          <span class="step completed">✓ Verificare email</span>
          <span class="step completed">✓ Configurare 2FA</span>
        </div>

        <nz-alert 
          nzType="warning" 
          nzMessage="Important!" 
          nzDescription="Salvează aceste coduri de rezervă într-un loc sigur. Le vei putea folosi pentru a accesa contul dacă pierzi accesul la aplicația de autentificare."
          nzShowIcon
        ></nz-alert>

        <div class="backup-codes-container">
          <div class="backup-codes-grid">
            <code *ngFor="let code of backupCodes">{{ code }}</code>
          </div>
        </div>

        <div class="backup-actions">
          <button nz-button (click)="copyBackupCodes()">
            <i class="fa fa-copy"></i>
            {{ backupCodesCopied ? 'Copiat!' : 'Copiază codurile' }}
          </button>
          <button nz-button (click)="downloadBackupCodes()">
            <i class="fa fa-download"></i>
            Descarcă ca fișier
          </button>
        </div>

        <div class="backup-note">
          <small>
            Fiecare cod poate fi folosit o singură dată. După ce folosești un cod, acesta nu va mai funcționa.
          </small>
        </div>

        <button 
          nz-button
          class="login-form-button login-form-margin"
          [nzType]="'primary'"
          (click)="continueToApp()"
        >
          Am salvat codurile - Continuă în aplicație
        </button>
      </div>
    </div>
  </ng-container>
</ng-template>

